'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _date_formatter = require('../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _ramda = require('ramda');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _constants = require('../../../packages/common-utilities/src/constants.js');

var _constants2 = _interopRequireDefault(_constants);

var _sanitize_utility = require('../../../packages/common-utilities/src/sanitize_utility.js');

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

var _collection_utility = require('common-utilities/src/collection_utility');

var _string_utility = require('../../../packages/common-utilities/src/string_utility');

var _string_utility2 = _interopRequireDefault(_string_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MorningstarRatings = function (_React$Component) {
  _inherits(MorningstarRatings, _React$Component);

  function MorningstarRatings(props) {
    _classCallCheck(this, MorningstarRatings);

    return _possibleConstructorReturn(this, (MorningstarRatings.__proto__ || Object.getPrototypeOf(MorningstarRatings)).call(this, props));
  }

  _createClass(MorningstarRatings, [{
    key: 'getMorningstarRatingInfo',
    value: function getMorningstarRatingInfo(infoType) {
      return _collection_utility.CollectionUtility.find(this.props.morningstarRating, function (obj) {
        return obj.periodIndicator === infoType;
      });
    }
  }, {
    key: 'getRankNumber',
    value: function getRankNumber(infoType) {
      var info = this.getMorningstarRatingInfo(infoType);
      if ((0, _ramda.isNil)(info)) {
        return null;
      } else {
        return info.rankNumber;
      }
    }
  }, {
    key: 'getPeerGroupCount',
    value: function getPeerGroupCount(infoType) {
      var info = this.getMorningstarRatingInfo(infoType);
      if ((0, _ramda.isNil)(info) || (0, _ramda.isNil)(info.rankNumber)) {
        return null;
      } else {
        return info.peerGroupCount;
      }
    }
  }, {
    key: 'getStarRatings',
    value: function getStarRatings(rankNumber) {
      var rowCollection = [];
      if (!(0, _ramda.isNil)(rankNumber)) {
        for (var i = 0; i < 5; i++) {
          var starColor = "font-medium-gray";
          if (i < rankNumber) {
            starColor = "font-solid-black";
          }
          rowCollection.push(_react2.default.createElement('span', { className: 'icon-morning_star full width-20 margin-right-8 ' + starColor, key: i }));
        }
        return _react2.default.createElement(
          'div',
          { className: "margin-top-5" },
          rowCollection
        );
      } else {
        return _react2.default.createElement(
          'div',
          { className: 'disclaimer no-star' },
          '-'
        );
      }
    }
  }, {
    key: 'getFormatedPeerGroupCount',
    value: function getFormatedPeerGroupCount(peerGroupCount) {
      if ((0, _ramda.isNil)(peerGroupCount)) {
        return "-";
      } else {
        return peerGroupCount + " " + _string_utility2.default.getLocalizedString(this.props.intl, "Funds in Category", "pdp-overview-morningstar-funds-category-label");
      }
    }
  }, {
    key: 'getTextAlign',
    value: function getTextAlign(breakpoint, isDisclaimer) {
      if (breakpoint > 3) {
        return 'text-left ' + (!isDisclaimer ? "width-percent-25" : "");
      } else {
        return "text-center";
      }
    }
  }, {
    key: 'renderAnalystData',
    value: function renderAnalystData() {
      if ((0, _ramda.isNil)(this.props.morningstarOverallRating) || (0, _ramda.isNil)(this.props.morningstarOverallRating.morningstarMedalistRatingIndicator)) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'print-display font-regular sub-header-3 padding-bottom-10', 'data-testid': 'print-analyst-rating-data', style: { "display": "none" } },
        _react2.default.createElement('img', { className: 'height-20 width-25 padding-right-5',
          src: this.props.gaiaRedirectUrl + '/images/morningstar-analyst-rating.png',
          'data-testid': '' }),
        'Analyst Rating ',
        this.renderAsOfDateAnalystRating(),
        ': ',
        _constants2.default.getMedalistRatingIndicator(this.props.morningstarOverallRating.morningstarMedalistRatingIndicator)
      );
    }
  }, {
    key: 'renderAsOfDateAnalystRating',
    value: function renderAsOfDateAnalystRating() {
      if ((0, _ramda.isNil)(this.props.morningstarOverallRating) || (0, _ramda.isNil)(this.props.morningstarOverallRating.fundShareclassIndustryRatingDate)) {
        return null;
      }
      return _react2.default.createElement(
        'span',
        null,
        '(',
        _string_utility2.default.getLocalizedString(this.props.intl, "As of", "label-for-as-of"),
        ': ',
        this.props.morningstarOverallRating.fundShareclassIndustryRatingDate,
        ')'
      );
    }
  }, {
    key: 'renderPrintDisclosures',
    value: function renderPrintDisclosures() {
      return _react2.default.createElement(
        'div',
        { 'data-testid': 'print-disclosures', className: 'print-display', style: { "display": "none" } },
        this.props.disclosure && _react2.default.createElement('div', { className: 'font-slate-grey disclosure disclaimer print-page-break margin-bottom-15 text-justified', dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(this.props.disclosure) } }),
        this.props.analystDisclosure && _react2.default.createElement('div', { className: 'font-slate-grey disclosure disclaimer print-page-break margin-bottom-15 text-justified', dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(this.props.analystDisclosure) } })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var ovrRating = this.getRankNumber('OVR');
      var threeYrRating = this.getRankNumber('3YR');
      var fiveYrRating = this.getRankNumber('5YR');
      var tenYrRating = this.getRankNumber('10Y');

      return _react2.default.createElement(
        'div',
        { 'data-testid': 'morningstar-ratings-card' },
        _react2.default.createElement(
          _card_component2.default,
          {
            headerTitle: 'Morningstar Ratings: ' + this.props.peerGroupCategory,
            headerTitleId: "fund-ratings-morningstar-header",
            headerTitleLabel: "fund-ratings-morningstar-header",
            headerLabel: _react2.default.createElement(
              'div',
              { 'data-testid': 'fund-ratings-morningstar-effective-date',
                className: 'margin-top--25 ' + (this.props.breakpoint < 3 ? "display-inline padding-horizontal-16" : "float-right text-right") + ' disclaimer2' },
              ' ',
              _string_utility2.default.getLocalizedString(this.props.intl, "As of", "label-for-as-of-morning-star"),
              ' ',
              _date_formatter2.default.getDateInSlashFormatOrNA(this.props.morningstarRatingEffectiveDate)
            ),
            disclosureText: this.props.disclosure,
            breakpoint: this.props.breakpoint,
            placementId: "pdpCardMorningstarRatings",
            hideDisclosureinCardForPrintView: true
          },
          this.renderAnalystData(),
          _react2.default.createElement(
            'div',
            { className: 'row margin-horizontal-0' },
            _react2.default.createElement(
              'div',
              { 'data-testid': 'fund-ratings-morningstar-overall-rating-div', id: 'fund-ratings-morningstar-overall-rating-div', className: "col-md-3 col-xs-6 col-sm-6 font-book margin-horizontal-0 margin-vertical-5 ratings-card-section " + this.getTextAlign(this.props.breakpoint) },
              _react2.default.createElement(
                'span',
                { className: 'title sub-header-3' },
                _string_utility2.default.renderFormattedLabel("Overall", "pdp-overview-morningstar-overall-label")
              ),
              _react2.default.createElement(
                'span',
                { className: 'font-light font-20', 'data-testid': 'fund-ratings-morningstar-overall-rating', id: 'fund-ratings-morningstar-overall-rating' },
                this.getStarRatings(ovrRating)
              ),
              _react2.default.createElement(
                'span',
                { className: 'sr-only' },
                (0, _ramda.isNil)(ovrRating) ? "0" : ovrRating,
                ' Star Morningstar overall rating'
              ),
              _react2.default.createElement(
                'div',
                { className: "disclaimer2 margin-top-10 " + this.getTextAlign(this.props.breakpoint, true), 'data-testid': 'fund-ratings-morningstar-overall-group-count' },
                this.getFormatedPeerGroupCount(this.getPeerGroupCount('OVR'))
              )
            ),
            _react2.default.createElement(
              'div',
              { 'data-testid': 'fund-ratings-morningstar-3yr-rating-div', id: 'fund-ratings-morningstar-3yr-rating-div', className: "col-md-3 col-xs-6 col-sm-6 font-book margin-horizontal-0 margin-vertical-5 ratings-card-section " + this.getTextAlign(this.props.breakpoint) },
              _react2.default.createElement(
                'span',
                { className: 'title sub-header-3' },
                _string_utility2.default.renderFormattedLabel("3 Year", "pdp-overview-morningstar-three-year-label")
              ),
              _react2.default.createElement(
                'span',
                { className: 'font-light font-20', 'data-testid': 'fund-ratings-morningstar-3yr-rating', id: 'fund-ratings-morningstar-3yr-rating' },
                this.getStarRatings(threeYrRating)
              ),
              _react2.default.createElement(
                'span',
                { className: 'sr-only' },
                (0, _ramda.isNil)(threeYrRating) ? "0" : threeYrRating,
                ' Star Morningstar 3 YEAR rating'
              ),
              _react2.default.createElement(
                'div',
                { className: "disclaimer2 margin-top-10 " + this.getTextAlign(this.props.breakpoint, true), 'data-testid': 'fund-ratings-morningstar-3yr-group-count', id: 'fund-ratings-morningstar-3yr-group-count' },
                this.getFormatedPeerGroupCount(this.getPeerGroupCount('3YR'))
              )
            ),
            _react2.default.createElement(
              'div',
              { 'data-testid': 'fund-ratings-morningstar-5yr-rating-div', id: 'fund-ratings-morningstar-5yr-rating-div', className: "col-md-3 col-xs-6 col-sm-6 font-book font-16 margin-horizontal-0 margin-vertical-5 ratings-card-section " + this.getTextAlign(this.props.breakpoint) },
              _react2.default.createElement(
                'span',
                { className: 'title sub-header-3' },
                _string_utility2.default.renderFormattedLabel("5 Year", "pdp-overview-morningstar-five-year-label")
              ),
              _react2.default.createElement(
                'span',
                { className: 'font-light font-20', 'data-testid': 'fund-ratings-morningstar-5yr-rating', id: 'fund-ratings-morningstar-5yr-rating' },
                this.getStarRatings(fiveYrRating)
              ),
              _react2.default.createElement(
                'span',
                { className: 'sr-only' },
                (0, _ramda.isNil)(fiveYrRating) ? "0" : fiveYrRating,
                ' Star Morningstar 5 YEAR rating'
              ),
              _react2.default.createElement(
                'div',
                { className: "disclaimer2 margin-top-10 " + this.getTextAlign(this.props.breakpoint, true), 'data-testid': 'fund-ratings-morningstar-5yr-group-count' },
                this.getFormatedPeerGroupCount(this.getPeerGroupCount('5YR'))
              )
            ),
            _react2.default.createElement(
              'div',
              { 'data-testid': 'fund-ratings-morningstar-10yr-rating-div', id: 'fund-ratings-morningstar-10yr-rating-div', className: "col-md-3 col-xs-6 col-sm-6 font-book font-16 margin-horizontal-0 margin-vertical-5 ratings-card-section " + this.getTextAlign(this.props.breakpoint) },
              _react2.default.createElement(
                'span',
                { className: 'title sub-header-3' },
                _string_utility2.default.renderFormattedLabel("10 Year", "pdp-overview-morningstar-ten-year-label")
              ),
              _react2.default.createElement(
                'span',
                { className: 'font-light font-20', 'data-testid': 'fund-ratings-morningstar-10yr-rating', id: 'fund-ratings-morningstar-10yr-rating' },
                this.getStarRatings(tenYrRating)
              ),
              _react2.default.createElement(
                'span',
                { className: 'sr-only' },
                (0, _ramda.isNil)(tenYrRating) ? "0" : tenYrRating,
                ' Star Morningstar 10 YEAR rating'
              ),
              _react2.default.createElement(
                'div',
                { className: "disclaimer2 margin-top-10 " + this.getTextAlign(this.props.breakpoint, true), 'data-testid': 'fund-ratings-morningstar-10yr-group-count', id: 'fund-ratings-morningstar-10yr-group-count' },
                this.getFormatedPeerGroupCount(this.getPeerGroupCount('10Y'))
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { 'data-testid': 'morningstar-print-disclosure' },
            this.renderPrintDisclosures()
          )
        )
      );
    }
  }]);

  return MorningstarRatings;
}(_react2.default.Component);

exports.default = MorningstarRatings;